import { ServiceRoutes } from './routing.models';

export interface RoutingKey {
  key: string;
  route?: string;
}

export function getRouteForKey(item: RoutingKey): string {
  const { key, route } = item;

  if (key === 'web') {
    return route || '/';
  }

  if (key === 'view' && route === 'kycManualReviewPending') {
    return '/kyc-verification';
  }

  const baseRoute = ServiceRoutes[key];
  if (baseRoute) {
    if (route) {
      // Ensure proper path joining with a single slash
      const basePath = baseRoute.endsWith('/') ? baseRoute.slice(0, -1) : baseRoute;
      const routePath = route.startsWith('/') ? route : `/${route}`;
      return `${basePath}${routePath}`;
    }
    return baseRoute;
  }

  return '/';
}

export function routePath(key: string): string {
  const fullPath = ServiceRoutes[key] || '/';
  return fullPath.replace(/^\/+/, '');
}

export function stripAccountsPrefix(key: string): string {
  const fullPath = ServiceRoutes[key] || '';
  return fullPath.replace(/^\/?accounts\/?/, '');
}
